import { render, staticRenderFns } from "./pesquisassatisfacao.vue?vue&type=template&id=4f18d53f"
import script from "./pesquisassatisfacao.vue?vue&type=script&lang=js"
export * from "./pesquisassatisfacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports